import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import AlphabetSearch from '@/components/ui/alphabet-search/AlphabetSearch';
import AuthorsList from '@/components/ui/authors-list/AuthorsList';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { AUTHORS_FOR_PAGE } from '@/helpers/variables';
import { IAuthorsPage, ISearchAuthor } from '@/interfaces/authorsPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { getCurrentPageName } from '@/helpers/helpers';
import AuthorsListLetter from '@/components/ui/authors-list/AuthorsListLetter';

interface IAuthors extends IWidgetsSideBar {
  authors?: IAuthorsPage;
  letterData?: ISearchAuthor;
  letterSign?: string;
}

const Authors: FC<IAuthors> = ({ authors, letterData, letterSign, todayWidget, popularBooksWidget }) => {
  const pages = authors?.total_count || letterData?.total_count;
  const pagesCount = Math.ceil(pages ? pages / AUTHORS_FOR_PAGE : 1);

  const currentPage = authors?.page || letterData?.page || 1;

  const currentPath = String(useGetUrlPath());
  const isSearchLetterPage = currentPath.includes('letter');
  const currentPathSplit = currentPath.split('/');

  const getSearchLetterWord = () => {
    if (currentPath.includes('page=')) {
      return currentPathSplit[currentPathSplit.length - 2];
    }
    return currentPathSplit[currentPathSplit.length - 1];
  };

  //Seo block
  const SEO_TITLE = `Список авторов по алфавиту :: BookZ.ru${getCurrentPageName(currentPage)}`;
  const SEO_DESCRIPTION = 'Список авторов книг по алфавиту - читайте онлайн или скачивайте книги на сайте электронной библиотеки BookZ.ru.';
  const SEO_CANONICAL = '/authors';

  return (
    <Layout
      title={SEO_TITLE}
      description={SEO_DESCRIPTION}
      canonicalHref={SEO_CANONICAL}
      pageHref={useGetUrlPath()}
      breadcrumbs={<Breadcrumbs firstPageName="Полный список авторов библиотеки" />}
      todayWidget={todayWidget}
      popularBooksWidget={popularBooksWidget}
    >
      <SectionTitle name="Полный список авторов библиотеки" />
      <AlphabetSearch url={'/authors/letter/'} letterSign={String(letterSign)} title="Авторы по алфавиту" />

      {!!authors?.data.length && <AuthorsList data={authors.data} />}
      {!!letterData?.data.length && <AuthorsListLetter data={letterData.data} />}

      {/* Проверка на страницы поиска по букве */}
      <Pagination pagesCount={pagesCount ?? 0} postName={!!isSearchLetterPage ? `authors/letter/${getSearchLetterWord()}/page=` : `authors/page=`} />
    </Layout>
  );
};

export default Authors;
